import React from "react";
import { useSelector, useDispatch } from "react-redux";
import styles from "./SearchBar.module.css";
import { loadSubredditData } from "../Subreddit/subredditSlice";

export function SearchBar() {
  const dispact = useDispatch();
  const _handleKeyDown = (e) => {
    if (e.key === "Enter") {
      dispact(
        loadSubredditData({ subreddit: "search", search: e.target.value })
      );
    }
  };
  return (
    <div className={styles.searchBar}>
      <svg
        height="16"
        width="16"
        viewBox="0 0 24 24"
        aria-label="Search icon"
        role="img"
      >
        <path d="M10 16c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m13.12 2.88l-4.26-4.26A9.842 9.842 0 0 0 20 10c0-5.52-4.48-10-10-10S0 4.48 0 10s4.48 10 10 10c1.67 0 3.24-.41 4.62-1.14l4.26 4.26a3 3 0 0 0 4.24 0 3 3 0 0 0 0-4.24"></path>
      </svg>
      <input
        className={styles.searchInput}
        key="random1"
        placeholder={"search reddit"}
        onKeyDown={_handleKeyDown}
      />
    </div>
  );
}
